module.exports = __webpack_public_path__ + "img/profile_img01.ec24d087.jpg";